import type { ReactNode } from 'react'
import { BoxesIcon, DiamondIcon, HexagonIcon, SparkleIcon } from '@nwwp/ui-shadcn'

export const STEPS: { title: string; body: string; icon: ReactNode }[] = [
  {
    title: 'Share your goals',
    body: 'Tell us about your financial situation and what matters most right now.',
    icon: <SparkleIcon width={32} height={32} color="var(--color-green)" />,
  },
  {
    title: 'Meet your advisor',
    body: 'Schedule a free call with a NerdWallet Wealth Partners advisor.',
    icon: (
      <div className="flex size-8 items-center justify-center">
        <DiamondIcon />
      </div>
    ),
  },
  {
    title: 'Make progress',
    body: 'Get a personalized plan and stay on track toward your goals.',
    icon: <HexagonIcon width={32} height={32} />,
  },
]

export const CAPABILITIES: { label: string; icon: ReactNode }[] = [
  { label: 'Investment Management', icon: <BoxesIcon width={24} height={24} /> },
  {
    label: 'Tax Strategy',
    icon: (
      <div className="flex size-6 items-center justify-center">
        <DiamondIcon />
      </div>
    ),
  },
  { label: 'Retirement Planning', icon: <SparkleIcon width={24} height={24} color="var(--color-green-dark)" /> },
]
